<template>
  <Header />
  <div class="container container-faq container-faq-init">
    <h4>よくある質問</h4>
    <FaqSection
      no="01"
      title="ポスティングや新聞折込って効果あるのですか？"
      subTitle="特定の地域にエリアを絞って複数回情報の発信が可能な広告手段となります。それぞれの特徴を媒体紹介ページにて紹介しておりますのでご確認下さい。"
      autoOpen="open"
    />
    <FaqSection
      no="02"
      title="ＡＤＸでは配布したい条件で依頼ができないのですが対応できないという事ですか？"
      subTitle="対応できる可能性もございます。特殊な配布物や条件、短納期での配布、デザイン等をご希望の場合は弊社まで直接お問合せ下さいお問合せフォーム　
      
      https://www.ato-co.jp/contact/
      株式会社アト 0120－555－001"
    />
    <FaqSection
      no="03"
      title="注文の仕方が分からないので教えてください。"
      subTitle="ご利用ガイドがございますのでこちらをご確認ください。"
    />
    <FaqSection
      no="04"
      title="ポスティングでクレームが発生した場合はどうすれば良いですか？"
      subTitle="広告に記載のある番号へ連絡が入ってしまいます。
ポスティングに対する内容のクレームが発生した場合は
配布の責任者から折り返す旨をお伝え頂き、弊社までご連絡をお願いしております。
その後は、謝罪・回収は弊社で対応致しますのでお気軽にご連絡下さい。
株式会社アト 0120－〇〇〇―〇〇〇  "
    />
    <FaqSection
      no="05"
      title="どういうポストは配布がされないのですか？"
      subTitle="チラシや郵便物が詰まったポスト”
詰まっているポストに無理やり入れてしまうと、チラシが折れ曲がってしまい、クレームにもつながる為、投函しておりません。また転居など住人が居ない可能性もございます。
また、過去に投函に関してご指摘を頂いたポストはデータベースに登録されており、予め投函を行わないよう対策を取っております。"
    />
    <FaqSection
      no="06"
      title="もっと早く、急ぎでポスティングをお願いしたいです。"
      subTitle="ＡＤＸ上では注文ができなくても直接お問合せ頂ければ営業担当にて対応可否を確認させていただきますのでご連絡ください。
お問合せフォーム　https://www.ato-co.jp/contact/
株式会社アト 0120－555－001"
    />
    <FaqSection
      no="07"
      title="原稿、入稿データのアップロード期日、入金期日を過ぎてしまった場合はどうすれば良いですか？"
      subTitle="大変申し訳ございませんが注文は自動でキャンセル扱いとさせていただきますので、再度注文をお願い致します。"
    />
    <FaqSection
      no="08"
      title="ポスティング、新聞折込のみで注文をしているのですが納品期日までに配布物の納品ができ
なそうな場合はどうすればよろしいでしょうか。"
      subTitle="お手数ですが注文日・注文番号をご確認のうえで弊社までご連絡下さい。
株式会社アト　0120－〇〇〇－〇〇〇
場合によっては配布日程が大幅に後ろ倒しとなる可能性がございますのでご了承下さい。"
    />
    <FaqSection
      no="09"
      title="お支払いはどのようにすれば良いでしょうか？"
      subTitle="クレジットカード決済、ペイジー、コンビニ支払い、銀行振込から選択が可能です。
　　商品注文後のお支払方法の登録画面よりご希望のお支払方法を選択してください。
"
    />
    <FaqSection
      no="10"
      title="データの入稿(原稿のアップ)はどこからできますか？"
      subTitle="ホーム画面の【注文(進行状況)の管理】から入稿を行いたい商品を選択してください。
　　オーダー/詳細 画面の 入稿データをアップロード という箇所から入稿をお願い致します。"
    />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import FaqSection from "../components/faq/FaqSection.vue";

export default {
  name: "Blank",
  components: {
    Header,
    FaqSection,
  },
};
</script>
